import React, { Component } from 'react';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';

class MultipleCheckboxs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOptions: []
    };

    this.options = this.props.options;
    this.refSelectCheckboxes = null;
    this.timeoutHandleChangeOptions = null;
  }

  componentDidMount() {
    this.initOptions();
    this.getSelectedOptions('init');
  }

  componentWillReceiveProps(nextProps) {
    // if the Cancel button was pressed on the parent component, then it calls this function to re-render the state but without calling the handleChangeOptions method of the parent component.
    if (nextProps.actionButton === 'cancel') {
      this.getSelectedOptions(nextProps.actionButton);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutHandleChangeOptions);
  }

  /**
   * Adds item "ALL" to the beginning of the options list
   */
  initOptions = () => {
    const { language } = this.props;
    this.options = [
      {
        id: 0,
        label: language.all,
        value: '*'
      },
      ...this.options
    ];
  }

  /**
   * Gets the selected options so that they are marked in the list when mounting the component
   * @param {string} actionButton button action
   */
  getSelectedOptions = (actionButton) => {
    const { options, selectedOptions, alias, handleChangeOptions } = this.props;
    const findSelectedOptions = [];

    selectedOptions.map((item) => {
      const findOption = options.find((o) => o.value === item);
      if (findOption) {
        findSelectedOptions.push(findOption);
      }
    });

    this.setState({
      selectedOptions: findSelectedOptions
    });

    // if a button action other than "cancel" is sent, it invokes the method to change the options state of the parent screen, since if this adjustment is not made
    // a loop of state changes occurs between parent and child
    if (actionButton !== 'cancel') {
      this.timeoutHandleChangeOptions = setTimeout(() => {
        handleChangeOptions({
          alias,
          selectedOptions: findSelectedOptions,
          actionButton
        });
      }, 500);
    }
  }

  /**
   * Gets labels of the selected items
   * @param {Object} event event raised by the ReactMultiSelectCheckboxes component
   */
  getDropdownButtonLabel = (event) => {
    const { language } = this.props;
    const { selectedOptions } = this.state;
    const { placeholderButtonLabel, value } = event;
    const label = placeholderButtonLabel;

    if (value) {
      // create a comma separated list
      const listJoin = value.map((o) => o.label).join(', ')

      // if the item "ALL (value === '*')" is checked, it returns a message that all items are selected
      if (value.some((o) => o.value === '*')) {
        return language.all;
      }

      // if no item is selected, returns 'ALL'
      if (value.length === 0) {
        return label;
      }

      // if there are more than 3 values selected, returns the 'total of selected + the list'
      if (value.length >= 3) {
        return `(+${selectedOptions.length}) ${listJoin} `;
      }

      // if the total is between '0 and 2', return only the list
      return listJoin;
    }

    // returns the default value
    return label;
  }

  /**
   * Handles the change event for a selection component.
   * @param {Array} value - The current selected values.
   * @param {Object} event - The event object containing information about the change event.
   */
  handleChange = (value, event) => {
    const { alias, handleChangeOptions } = this.props;
    let changeOptions = [];

    // ------------------------------------------
    // Logic for the "ALL" item (value === '*')
    if (event.option.value === '*') {
      if (event.action === 'select-option') {
        changeOptions = this.options;
      } else if (event.action === 'deselect-option') {
        changeOptions = [];
      }

      this.refSelectCheckboxes.toggleOpen();
    } else {
      // ------------------------------------------
      // Logic for other items
      if (event.action === 'deselect-option') {
        changeOptions = value.filter((o) => o.value !== '*');
      } else if (value.length === this.options.length - 1) {
        // If all options are selected without selecting the "ALL" item, select all options including "ALL".
        changeOptions = this.options;
      } else {
        changeOptions = value;
      }
    }

    this.setState({
      selectedOptions: changeOptions
    });

    handleChangeOptions({
      alias,
      selectedOptions: changeOptions
    });
  }

  /**
   * Handles the clear action to reset the selected options to an empty array.
   */
  handleClear = () => {
    const { alias, handleChangeOptions } = this.props;

    this.setState({
      selectedOptions: []
    });

    handleChangeOptions({
      alias,
      selectedOptions: []
    });
  }

  render() {
    const { language } = this.props;

    return (
      <div className="multiple-checkboxs">
        <ReactMultiSelectCheckboxes
          options={this.options}
          placeholderButtonLabel={language.all}
          placeholder={`${language.search}...`}
          getDropdownButtonLabel={this.getDropdownButtonLabel}
          value={this.state.selectedOptions}
          onChange={this.handleChange}
          noOptionsMessage={() => language.noMatches}
          ref={ref => this.refSelectCheckboxes = ref}
        />

        {
          (this.state.selectedOptions.length > 0) && (
            <div className="multiple-box-clear-button">
              <span onClick={this.handleClear}>
                <i className="fas fa-times-circle" />
              </span>
            </div>
          )
        }
      </div>
    );
  }
}

export default MultipleCheckboxs;



// WEBPACK FOOTER //
// ./source/client/components/common/inputs/multipleCheckboxs.jsx